import { useState, useEffect, useCallback } from "react";
import { Select, SelectProps } from "antd";
import { searchProject, getProject, lookupAllProject } from '../../api/project';
import { debounce, uniqBy } from 'lodash';

export default function ProjectLookup({
    value, history = false, ...selectProps
}: Omit<SelectProps, 'options'> & {history?: boolean}) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<Project[] | {
        "projectId": any,
        "name": string
      }[]>([]);
    const [keywords, setKeywords] = useState('');
    const fetchData = useCallback(debounce(({ keywords, value }) => {
        setLoading(true)
        if (value && !keywords) {
            getProject(value)
                ?.then((data) => setData([data]))
                .finally(() => setLoading(false))
        } else {
            if (history) {
                lookupAllProject(keywords)
                ?.then((data) => setData(data?.map(i => {
                    return {
                        ...i,
                        name: i.projectName
                    }
                })))
                .finally(() => setLoading(false))
            } else {
                searchProject({ projectName: keywords, })
                ?.then((data) => setData(data.data))
                .finally(() => setLoading(false))
            }
        }

    }, 500), [setData, setLoading, history]);
    useEffect(() => {
        fetchData({ keywords, value })
    }, [fetchData, keywords, value]);
    const optionList = uniqBy([...data], 'projectId');
    return <Select
        {...selectProps}
        loading={loading}
        options={optionList?.map(i => {
            return {
                ...i,
                value: i.projectId,
                label: i.name,
            }
        })}
        defaultActiveFirstOption={false}
        filterOption={false}
        value={value}
        searchValue={keywords}
        allowClear
        onSearch={keywords => {
            setKeywords(keywords)
        }}
        showSearch
    />
}